import { useQuery } from '@tanstack/react-query'
import { api } from '../client'
import type { QualityRealtimeData, QualityHistoryData } from './useTracker'

export function useTrackerQualityRealtime(siteId: string | undefined) {
  return useQuery<QualityRealtimeData>({
    queryKey: ['tracker-quality-realtime', siteId],
    queryFn: () => api.get<QualityRealtimeData>(`/tracker/sites/${siteId}/quality/realtime`),
    enabled: !!siteId,
    refetchInterval: 5000,
  })
}

export function useTrackerQualityHistory(siteId: string | undefined, days = 30, filters?: { quality?: string; source?: string; page?: number }) {
  const params = new URLSearchParams({ days: String(days) })
  if (filters?.quality) params.set('quality', filters.quality)
  if (filters?.source) params.set('source', filters.source)
  if (filters?.page) params.set('page', String(filters.page))

  return useQuery<QualityHistoryData>({
    queryKey: ['tracker-quality-history', siteId, days, filters],
    queryFn: () => api.get<QualityHistoryData>(`/tracker/sites/${siteId}/quality/history?${params}`),
    enabled: !!siteId,
  })
}
